const marketReports = document.querySelectorAll('section.market-reports .year-btn');

if(marketReports) {
  marketReports.forEach(function(button, index) {
    button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            let parent = button.parentNode;
            if(!parent.classList.contains('open')) {
                parent.classList.add('open');
                button.setAttribute('aria-expanded', 'true');
            }
            else {
                parent.classList.remove('open');
                button.setAttribute('aria-expanded', 'false');
            }
        });
    });
}